import React from "react";
import { reportCards } from "../../../../data/workspaceData";
import { SectionHeader } from "../../common/WorkspaceChrome";

export function ReportsView() {
  return (
    <>
    <section className="panel">
      <SectionHeader
        eyebrow="Reports"
        title="Founder, manager, employee, client, and instructor dashboards"
        text="Reports connect output, time, money, client progress, and team health."
      />
      <div className="report-grid">
        {reportCards.map((report) => (
          <article key={report.name}>
            <span>{report.name}</span>
            <strong>{report.metric}</strong>
            <small>{report.detail}</small>
          </article>
        ))}
      </div>
    </section>
    </>
  );
}
